/**
 * Impact Theme Fitment Finder
 * Vanilla JS, no external deps.
 */
(function() {
  'use strict';

  class FitmentFinder {
    constructor(element) {
      this.modal = element;
      this.container = this.modal.querySelector('.ff-container');
      this.progressBar = this.modal.querySelector('.ff-progress-fill');
      this.data = null;
      this.currentProduct = this.modal.dataset.productHandle || 'default';
      
      this.state = {
        step: 1,
        category: null,
        make: null,
        model: null
      };

      this.ui = {
        loading: this.modal.querySelector('.ff-loading'),
        step1: this.modal.querySelector('[data-step="1"]'),
        step2: this.modal.querySelector('[data-step="2"]'),
        step3: this.modal.querySelector('[data-step="3"]'),
        result: this.modal.querySelector('[data-step="result"]'),
        form: this.modal.querySelector('[data-step="form"]'),
        categoryList: document.getElementById('ff-category-list'),
        makeList: document.getElementById('ff-make-list'),
        modelList: document.getElementById('ff-model-list'),
        resultContent: document.getElementById('ff-result-content'),
        searchMake: document.getElementById('ff-search-make'),
        searchModel: document.getElementById('ff-search-model')
      };

      this.init();
    }

    init() {
      // Event Delegation
      this.modal.addEventListener('click', (e) => this.handleClicks(e));
      
      // Search Listeners
      this.ui.searchMake.addEventListener('input', (e) => this.filterList(e.target.value, 'ff-make-list'));
      this.ui.searchModel.addEventListener('input', (e) => this.filterList(e.target.value, 'ff-model-list'));

      // Global Triggers
      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-fitment-open], [data-fitment-open] *')) {
          e.preventDefault();
          this.open();
        }
      });
      
      // Keydown (Escape)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('is-open')) this.close();
      });

      // Inside your init() or constructor listener
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-fitment-open]');
  if (trigger) {
    e.preventDefault();
    this.lastTrigger = trigger; // Save the reference
    this.open();
  }
});

      // Data Load
      this.fetchData();
    }

    async fetchData() {
      try {
        const response = await fetch(window.fitmentDataUrl);
        if(!response.ok) throw new Error('Failed to load');
        const json = await response.json();
        
        // Use product specific data or fallback to default
        this.data = json[this.currentProduct] || json['default'] || {};
        
        this.ui.loading.style.display = 'none';
        this.renderCategories();
      } catch (err) {
        console.error('Fitment Data Error:', err);
        this.ui.loading.textContent = 'Error loading data. Please use the contact form.';
        // Fallback to form
        setTimeout(() => this.goToStep('form'), 1000);
      }
    }

   open() {
  this.modal.style.display = 'flex'; 
  this.modal.classList.add('is-open');
  
  // Accessibility Fixes:
  this.modal.setAttribute('aria-hidden', 'false');
  this.modal.removeAttribute('inert');
  
  document.body.style.overflow = 'hidden'; 
  this.emitEvent('modal_open');
  this.reset();
  
  // Focus the close button or the container after a tiny delay 
  // to ensure the browser has registered the removal of 'inert'
  setTimeout(() => {
    this.modal.querySelector('.ff-close-btn').focus();
  }, 50);
}
    
    // Specifically for form success re-opening
    openSuccess() {
        this.modal.classList.add('is-open');
        this.goToStep('form');
    }

   close() {
  this.modal.classList.remove('is-open');
  document.body.style.overflow = '';
  
  // Accessibility Fixes:
  this.modal.setAttribute('aria-hidden', 'true');
  this.modal.setAttribute('inert', '');

  setTimeout(() => {
    if (!this.modal.classList.contains('is-open')) {
      this.modal.style.display = 'none';
    }
  }, 300);

  // Return focus to the button that opened it (Standard A11y practice)
  if (this.lastTrigger) {
    this.lastTrigger.focus();
  }
}

    reset() {
      this.state = { step: 1, category: null, make: null, model: null };
      this.goToStep(1);
    }

    handleClicks(e) {
  const target = e.target;
  
  // Close
  if (target.hasAttribute('data-ff-close')) {
    this.close();
    return;
  }

  // --- NEW: Lock Switcher Logic ---
  const lockTab = target.closest('.ff-lock-tab');
  if (lockTab) {
    const selectedLock = lockTab.dataset.lock;
    // We pass the current model and the newly selected lock to re-render
    this.renderResult(this.state.model, selectedLock);
    return;
  }
  // --------------------------------

  // Actions
  const action = target.closest('[data-ff-action]')?.dataset.ffAction;
  if (action) {
    if (action === 'back') this.goBack();
    if (action === 'restart') this.reset();
    if (action === 'go-other') this.goToStep('form');
    return;
  }

  // Selections
  const optionBtn = target.closest('.ff-btn-option');
  if (optionBtn) {
    const value = optionBtn.dataset.value;
    const type = optionBtn.dataset.type; // category, make, model

    if (type === 'category') this.selectCategory(value);
    if (type === 'make') this.selectMake(value);
    if (type === 'model') this.selectModel(value);
  }
}

    goToStep(step) {
      // Hide all
      Object.values(this.ui).forEach(el => {
        if(el instanceof HTMLElement && el.classList.contains('ff-step')) {
           el.classList.add('hidden');
        }
      });

      // Show specific
      if (step === 'result') {
        this.ui.result.classList.remove('hidden');
        this.progressBar.style.width = '100%';
      } else if (step === 'form') {
        this.ui.form.classList.remove('hidden');
        this.progressBar.style.width = '100%';
      } else {
        this.ui[`step${step}`].classList.remove('hidden');
        this.progressBar.style.width = `${step * 33}%`;
      }
      
      this.state.step = step;
    }

    goBack() {
      if (this.state.step === 3) this.goToStep(2);
      else if (this.state.step === 2) this.goToStep(1);
      else if (this.state.step === 'form') this.goToStep(1);
    }

    /* --- Logic --- */

    renderCategories() {
      const cats = Object.keys(this.data);
      let html = '';
      cats.forEach(cat => {
        html += `<button type="button" class="ff-btn-option" data-type="category" data-value="${cat}">${cat}</button>`;
      });
      this.ui.categoryList.innerHTML = html;
    }

    selectCategory(cat) {
      this.state.category = cat;
      this.emitEvent('category_selected', { category: cat });
      
      const makes = this.data[cat] ? Object.keys(this.data[cat]) : [];
      this.renderList(this.ui.makeList, makes, 'make');
      
      // Handle Search visibility
      if (makes.length > 15) this.ui.searchMake.classList.remove('hidden');
      else this.ui.searchMake.classList.add('hidden');
      this.ui.searchMake.value = ''; // Reset search

      this.goToStep(2);
    }

    selectMake(make) {
      this.state.make = make;
      this.emitEvent('make_selected', { make: make });

      const models = this.data[this.state.category][make] ? Object.keys(this.data[this.state.category][make]) : [];
      this.renderList(this.ui.modelList, models, 'model');

      if (models.length > 15) this.ui.searchModel.classList.remove('hidden');
      else this.ui.searchModel.classList.add('hidden');
      this.ui.searchModel.value = '';

      this.goToStep(3);
    }

    selectModel(model) {
      this.state.model = model;
      this.emitEvent('model_selected', { model: model });
      this.renderResult(model);
      this.goToStep('result');
    }

    renderList(container, items, type) {
      let html = '';
      items.sort().forEach(item => {
        html += `<button type="button" class="ff-btn-option" data-type="${type}" data-value="${item}">${item}</button>`;
      });
      container.innerHTML = html;
    }

    filterList(query, listId) {
      const list = document.getElementById(listId);
      const buttons = list.querySelectorAll('button');
      const q = query.toLowerCase();
      buttons.forEach(btn => {
        const text = btn.textContent.toLowerCase();
        btn.style.display = text.includes(q) ? '' : 'none';
      });
    }

    renderResult(model, activeLockKey = null) {
  const modelData = this.data[this.state.category][this.state.make][model];
  
  if (!modelData || !modelData.locks) {
    this.ui.resultContent.innerHTML = '<p>Data for this model is currently being updated.</p>';
    return;
  }

  const lockKeys = Object.keys(modelData.locks);
  const currentLockKey = activeLockKey || lockKeys[0];
  const resultData = modelData.locks[currentLockKey];

  // 1. Selector Tabs
  let selectorHtml = '<div class="ff-lock-selector">';
  lockKeys.forEach(k => {
    const active = k === currentLockKey ? 'is-active' : '';
    selectorHtml += `<button type="button" class="ff-lock-tab ${active}" data-lock="${k}">${k}</button>`;
  });
  selectorHtml += '</div>';

  // 2. Media Logic (FIXED HERE)
  let mediaHtml = '';
  if (resultData.mediaUrl) {
    if (resultData.mediaType === 'video' || resultData.mediaUrl.includes('.mp4')) {
      mediaHtml = `<div class="ff-media-container"><video src="${resultData.mediaUrl}" controls playsinline autoplay muted loop style="width:100%"></video></div>`;
    } else {
      // Changed ${key} to ${currentLockKey} to fix the ReferenceError
      mediaHtml = `<div class="ff-media-container"><img src="${resultData.mediaUrl}" alt="Litelok ${currentLockKey} on ${model}" style="width:100%"></div>`;
    }
  }

  // 3. Final Output
  this.ui.resultContent.innerHTML = `
    <h3 class="ff-result-title">${this.state.make} ${model}</h3>
    ${selectorHtml}
    ${mediaHtml}
    <p class="ff-caption">${resultData.caption || ''}</p>
  `;
}

    emitEvent(name, detail = {}) {
      const event = new CustomEvent(`litelok:fitment_${name}`, {
        detail: { ...detail, product: this.currentProduct }
      });
      window.dispatchEvent(event);
    }
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('ff-modal');
    if (modal) {
      window.FitmentFinder = new FitmentFinder(modal);
    }
  });
})();